module.exports = __webpack_public_path__ + "media/images/media-elements/unmute-581d8a30b5117c1b320f1af5cb897cfd.svg";